import { IBar, IScoreEditorThis, TClef } from "../../../../../common/types";

export function handleSwapVoices(this: IScoreEditorThis, index: number, direction: 1 | -1) {
  const score = { ...this.state.score };
  const voice: IBar[] = score["bars" + (index || "")];
  const voiceClef: TClef = score["clef" + (index || "")];
  const voiceOctave: number = score["octave" + index];
  const swap: IBar[] = score["bars" + (index + direction || "")];
  const swapClef: TClef = score["clef" + (index + direction || "")];
  const swapOctave: number = score["octave" + (index + direction)];
  score["bars" + (index || "")] = swap;
  score["clef" + (index || "")] = swapClef;
  score["octave" + index] = swapOctave;
  score["bars" + (index + direction || "")] = voice;
  score["clef" + (index + direction || "")] = voiceClef;
  score["octave" + (index + direction)] = voiceOctave;
  this.setState({ score });
}
